
import { BlogLoading } from "@/components/blog/BlogLoading";
import { BlogResults } from "@/components/blog/BlogResults";
import { InfiniteScrollLoader } from "@/components/blog/InfiniteScrollLoader";
import { BlogPost } from "@/types/blog";
import { RefObject } from "react";

interface BlogContentSectionProps {
  posts: BlogPost[];
  loading: boolean;
  loadingMore: boolean;
  hasMore: boolean;
  searchTerm: string;
  selectedCategoryName: string;
  selectedCategoryId: number | null;
  onResetFilters: () => void;
  loaderRef: RefObject<HTMLDivElement>;
  isCategoryChanging?: boolean;
}

export const BlogContentSection = ({
  posts,
  loading,
  loadingMore,
  hasMore,
  searchTerm,
  selectedCategoryName,
  selectedCategoryId,
  onResetFilters,
  loaderRef,
  isCategoryChanging = false
}: BlogContentSectionProps) => {
  // Mostra stato di caricamento quando:
  // - caricamento iniziale senza post
  // - cambio categoria attivo
  // - oppure quando loading è true e non ci sono post
  const shouldShowLoading = (loading && posts.length === 0) || isCategoryChanging;
  
  return (
    <>
      {/* Mostra stato di caricamento quando caricamento o durante cambio categoria */}
      {shouldShowLoading && <BlogLoading />}
      
      {/* Mostra risultati solo quando NON in caricamento E NON in cambio categoria */}
      {!shouldShowLoading && (
        <BlogResults 
          posts={posts}
          loading={loading}
          searchTerm={searchTerm}
          selectedCategory={selectedCategoryName}
          selectedCategoryId={selectedCategoryId}
          onResetFilters={onResetFilters}
        />
      )}
      
      {/* Mostra loader infinito solo se abbiamo post e non stiamo cambiando categoria */}
      {posts.length > 0 && !isCategoryChanging && (
        <InfiniteScrollLoader 
          ref={loaderRef}
          loading={loadingMore}
          hasMore={hasMore}
        />
      )}
    </>
  );
};
